var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({staticClass:"ma-2",attrs:{"color":"success","outlined":""}},'v-chip',attrs,false),on),[_vm._v(" Marca ")])]}}])},[_c('v-card',[_c('producto-filtro-marca',{attrs:{"type":"list"},on:{"select-marca":_vm.setMarca}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }